import { render, staticRenderFns } from "./trainEdit.vue?vue&type=template&id=1b23dc60&scoped=true&"
import script from "./trainEdit.vue?vue&type=script&lang=js&"
export * from "./trainEdit.vue?vue&type=script&lang=js&"
import style0 from "./trainEdit.vue?vue&type=style&index=0&id=1b23dc60&lang=stylus&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1b23dc60",
  null
  
)

export default component.exports